// app/javascript/controllers/audio_controller.js
import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static values = {recipientId: {type: String}}

    connect() {
        console.log("ConversationController:: connected");
        console.log(this.recipientIdValue);
        this.element.classList.remove('hidden');
        this.listenToTurbo();
        this.styleAllMessages();
    }
    styleAllMessages() {
        console.log("styleAllMessages");
        console.log("styleAllMessages");
        console.log("styleAllMessages");
        const messages = this.element.querySelectorAll("[data-sender-id]")
        messages.forEach((msg) => this.styleSingleMessage(msg))
    }
    styleSingleMessage(msgElement) {
        const senderId = Number(msgElement.getAttribute("data-sender-id"))
        const bubble = msgElement.querySelector(".chat-bubble")
        if (!bubble) return

        if (senderId.toString() === this.recipientIdValue.toString()) {
            msgElement.classList.add("chat-end")
            bubble.classList.add("chat-bubble-info")
        } else {
            msgElement.classList.add("chat-start")
            bubble.classList.add("chat-bubble-secondary")
        }
    }

    async markMessageRead(messageId) {
        console.log('markMessageRead');
        console.log('markMessageRead');
        console.log('markMessageRead');
        await fetch(`/messages/${messageId}/read`, {
            method: "POST",
            credentials: "same-origin",
            headers: {"X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content}
        })
    }

    formatHTML() {
        this.element.querySelectorAll('.message').forEach((e) => this.styleSingleMessage(e))
    }



    listenToTurbo(conversationId) {
        // JavaScript
        document.addEventListener("turbo:before-stream-render", (event) => {
            const templateEl = event.detail?.templateElement || event.target.templateElement;
            if (!templateEl) return;
            // The fragment that will be inserted
            const root = templateEl.content.firstElementChild;
            if (!root) return;
            this.styleSingleMessage(root);
            console.log(this.element);
            console.log(this.element);
            console.log(this.element);
            console.log(this.element);
            //
            this.element.scrollTo({behavior: "smooth", top: this.element.scrollHeight});
            // Scroll to down

            // const messages = this.element.querySelectorAll("[data-sender-id]")
            // messages.forEach((msg) => this.styleSingleMessage(msg))

            // You can also inspect action/target if needed:
            // const streamEl = event.target; // <turbo-stream action="append" target="messages">
            // const streamEl = event.target; // <turbo-strformatHTMLMessageeam action="append" target="messages">
            // const action = streamEl.getAttribute("action");
            // const target = streamEl.getAttribute("target");
        });

    }

}
